import React from 'react';

import Banner from 'buffers/Banner';
import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {Optional} from 'util/Types';

export default function OptionsBanner({bannerText}: {bannerText: Optional<React.ReactNode>}): JSX.Element {
  return (
    <BufferOptionsItem className="buffer-options-item--bannerContainer">
      {bannerText != null && <Banner message={bannerText} />}
    </BufferOptionsItem>
  );
}
